export const Navigation = (function ($) {
  "use strict";

  /* =================== public methods ================== */

  // main init method
  function Init() {
    //console.log("boilerplate module init");
    $("nav.mobile ul li a").click(function () {
      $("nav.mobile").removeClass("active");
    });

    $(window).scroll(function () {
      if ($(window).scrollTop() > 80 && $(window).width() > 800) {
        $("header.main").addClass("small");
      } else {
        $("header.main").removeClass("small");
      }
    });

    $("div.language-selector-wrapper").click(function () {
      $(this).toggleClass("hover");
    });

    $(".recht").click(function () {
      $(this).toggleClass("hover");
    });

    ToggleMobile();
  }

  function ToggleMobile() {
    $(".nav-mobile-toggle, .nav-mobile-close").click(() => {
      $("html,body").scrollTop(0);

      $("nav.mobile").css({
        height: $(window).height(),
      });
      $("nav.mobile").toggleClass("active");
    });
  }

  /* =============== export public methods =============== */
  return {
    Init: Init,
    ToggleMobile: ToggleMobile,
  };
})(jQuery);
